// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: zNvxG9XzGvoP
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Password1 from "../../Password1"; // plasmic-import: _8NThLJuHFRw/component
import CustomErrorComponent from "../../CustomErrorComponent"; // plasmic-import: 3fSxDxNzNmO_/component
import Button from "../../Button"; // plasmic-import: CLyiSGaOpklv/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicChildPassword.module.css"; // plasmic-import: zNvxG9XzGvoP/css

createPlasmicElementProxy;

export const PlasmicChildPassword__VariantProps = new Array();

export const PlasmicChildPassword__ArgProps = new Array();

const $$ = {};

function PlasmicChildPassword__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__gFxfo)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__gAfI
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h3
                data-plasmic-name={"h3"}
                data-plasmic-override={overrides.h3}
                className={classNames(
                  projectcss.all,
                  projectcss.h3,
                  projectcss.__wab_text,
                  sty.h3
                )}
              >
                {"Welcome to CollectWise"}
              </h3>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__likSb)}>
        <div className={classNames(projectcss.all, sty.freeBox__w5USt)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__vcYjb
            )}
          >
            {"Create your password"}
          </div>
          <Password1
            data-plasmic-name={"signupPasswordInput"}
            data-plasmic-override={overrides.signupPasswordInput}
            className={classNames("__wab_instance", sty.signupPasswordInput)}
          />

          <CustomErrorComponent
            data-plasmic-name={"customErrorInstance"}
            data-plasmic-override={overrides.customErrorInstance}
            className={classNames("__wab_instance", sty.customErrorInstance)}
            customErrorText={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__yYvqk
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Failed to login"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Failed to login"}
                    </span>
                  </React.Fragment>
                )}
              </div>
            }
          />
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___6F3Fp)}>
        <Button
          data-plasmic-name={"saveBtn"}
          data-plasmic-override={overrides.saveBtn}
          className={classNames("__wab_instance", sty.saveBtn)}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__v6Ftx
            )}
          >
            {"Submit"}
          </div>
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "h3", "signupPasswordInput", "customErrorInstance", "saveBtn"],
  h3: ["h3"],
  signupPasswordInput: ["signupPasswordInput"],
  customErrorInstance: ["customErrorInstance"],
  saveBtn: ["saveBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicChildPassword__ArgProps,
          internalVariantPropNames: PlasmicChildPassword__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicChildPassword__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicChildPassword";
  } else {
    func.displayName = `PlasmicChildPassword.${nodeName}`;
  }
  return func;
}

export const PlasmicChildPassword = Object.assign(
  // Top-level PlasmicChildPassword renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h3: makeNodeComponent("h3"),
    signupPasswordInput: makeNodeComponent("signupPasswordInput"),
    customErrorInstance: makeNodeComponent("customErrorInstance"),
    saveBtn: makeNodeComponent("saveBtn"),
    // Metadata about props expected for PlasmicChildPassword
    internalVariantProps: PlasmicChildPassword__VariantProps,
    internalArgProps: PlasmicChildPassword__ArgProps
  }
);

export default PlasmicChildPassword;
/* prettier-ignore-end */
